module.exports = __webpack_public_path__ + "img/icon_map_8_off_001.376cb44f.png";